var lib_core = require("lib-core");
var lib_geometry = require('lib-geometry');
var IpcDataModel = require("./footprint/ipcFootprintGenerator/index.js");
var PackageData = require("./package/packageData.js");
var FootprintInstanceData = require("./package/footprintInstanceData.js");
var FootprintData = require("./footprint/footprintData.js");
var IpcNameHelper = require("./footprint/ipcFootprintGenerator/ipcNameHelper.js");
var IpcDescriptionHelper = require("./footprint/ipcFootprintGenerator/ipcDescriptionHelper.js");
var IpcPackageParamHelper = require("./footprint/ipcFootprintGenerator/ipcPackageParamHelper.js");
var Model3DReference = require("./model3d/model3DReference.js");
var Datamodel_version = require("./datamodel_version.js");
var FootprintGeneratorAddHelper = require("./footprint/ipcFootprintGenerator/footprintGeneratorAddHelper.js");
var MetaDataUpdateHelper = require("./footprint/ipcFootprintGenerator/metaDataUpdateHelper.js");

if(typeof window === 'undefined') {
    var NodeFormData = require("form-data");
}

var Generate3DPackage = function(csAssetLoader, hubid) {
    this.packageData = new PackageData(true);
    this.contentServerAssetLoader = csAssetLoader;
    this.contentServerClient = csAssetLoader.dataManager;
    this.hub = hubid;
};

Generate3DPackage.prototype.generate3dPackageFromIPCData = function(ipcGeneratorData) {
    var self = this;
    
    var name = '';
    var description = '';
    var summary = '';


     //store paramteric data
    self.packageData.ipcParametricData(ipcGeneratorData);

    //generate footprint and 3d model
    return self.getFootprintInstanceFromIPCData(ipcGeneratorData)
    .then(function(footprintInstance) {
        self.packageData.footprintInstances.push(footprintInstance);

        name = footprintInstance.getTitle();
        description = footprintInstance.getDescription();
        summary = footprintInstance.getSummary();

        return self.get3dModelFromIPCData(name, description, summary, ipcGeneratorData);
    })
    .then(function(model3dAsset) {
        console.assert(model3dAsset);

        var newModel3dRef = new Model3DReference(model3dAsset.type, model3dAsset.id);
        self.packageData.model3d(newModel3dRef);

        //update package metadata
        MetaDataUpdateHelper.updatePackageMetaDataFromIPCParametricData(self.packageData, name, description, summary, name);

        //create package version
        return self.contentServerClient.createVersionedResource
        (
            {
                "name": name,
                "description": description,
                "summary": summary
            },
            'package',
            Datamodel_version,
            '1',
            'Auto Generated Package',
            self.packageData
        );
    })
    .then(function(asset) {
        console.log("Package with id " + asset.id + " is created.");
        return asset;
    })
    .catch(function(err) {
        lib_core.logError("PackageGenerator", err, lib_core.logError.criticality.MAJOR, "3d package cannot be generated.");
        throw err;
    });
};

Generate3DPackage.prototype.getFootprintInstanceFromIPCData = function(ipcGeneratorData) {
    if(!ipcGeneratorData) return Promise.reject(new Error("IPC paramteric data is missing."));

    var self = this;
    var assetType = 'footprint';
    var footprintData = new FootprintData(true);
    var ipcData = lib_core.clone(ipcGeneratorData);
    ipcData.initialize();

    footprintData.replicators.add(ipcData);
    
    footprintData.metaData().name(IpcNameHelper.getIpcName(ipcData));
    footprintData.metaData().description('<p>' + IpcDescriptionHelper.getReadableDescriptionFromIPCData(ipcData) + '</p>');
    footprintData.metaData().summary(IpcDescriptionHelper.getShortDescriptionFromIPCData(ipcData));
    
    return this.contentServerClient.createVersionedResource
    (
        {
            "name": footprintData.metaData().name(),
            "description": footprintData.metaData().description(),
            "summary": footprintData.metaData().summary()
        },
        assetType,
        Datamodel_version,
        '1',
        'Created by IPC generator',
        footprintData
    )
    .then(function(asset) {
        console.log("Footprint with id " + asset.id + " is created.");
        return self.contentServerAssetLoader.getDescription(assetType, asset.id, asset.version, true);
    })
    .then(function(footprintDescription) {
        return new FootprintInstanceData(footprintDescription);
    })
    .catch(function(err) {
        lib_core.logError("PackageGenerator", err, lib_core.logError.criticality.MAJOR, "Footprint cannot be generated.");
        throw err;
    });
};

Generate3DPackage.prototype.get3dModelFromIPCData = function(name, description, summary, ipcGeneratorData) {
    if(!ipcGeneratorData) return Promise.reject(new Error("IPC paramteric data is missing."));

    var self = this;
    var packageType = IpcNameHelper.getPackageTypeFor3dModelGeneration(ipcGeneratorData);
    var ipcParams = IpcPackageParamHelper.getParamsForPackage(ipcGeneratorData);
    var targetModelType = 'step';
    var assetType = '3dmodel';
    var assetId = null;

    return this.contentServerClient.generate3dModelForIPCPackageType(packageType, targetModelType, ipcParams, false)
    .then(function(modelJsonDescription) {
        var basicResource = {
            "name": name || "Test Model",
            "description": description || "A model generated from an ipc test",
            "summary": summary || "",
            "tags": ["3d Model", "Electronic"],
            "score": 0,
            "private": true,
            "hub": self.hub
        };

        return self.contentServerClient.createResource(basicResource, assetType).then(function(asset){
            assetId = asset.id;

            var fileName = name + '.' + targetModelType;
            var fileData, formData;

            if(typeof window === 'undefined') {
                fileData = Buffer.from(modelJsonDescription[targetModelType]);
                formData = new NodeFormData();
            } else {
                fileData = new Blob([modelJsonDescription[targetModelType]], {type : 'text/plain'});
                formData = new FormData();
            }

            formData.append(fileName, fileData, fileName);

            return self.contentServerClient.updateResourceModel(assetType, assetId, formData, false, true)
            .then(function() {
                return {
                    id: assetId,
                    type: assetType
                };
            }).catch(function(err) {
                lib_core.logError("PackageGenerator", err, lib_core.logError.criticality.MAJOR, "new model3d resource cannot be updated.");
                throw err;
            });
        })
        .catch(function(err) {
            lib_core.logError("PackageGenerator", err, lib_core.logError.criticality.MAJOR, "new model3d resource cannot be created.");
            throw err;
        });
    })
    .catch(function(err) {
        lib_core.logError("PackageGenerator", err, lib_core.logError.criticality.MAJOR, "3d model cannot be generated.");
        throw err;
    });
};

module.exports = Generate3DPackage;